
const joins = 'manager.profile,contacts,tools,skills,parts.fittings,parts.report,parts.codes';

export default {
    baseUrl: '/api',
    urls: {
        files: {
            show: 'files/show',
            download: 'files/download'
        },
        jobs: {
            list: `jobs?join=${joins}`,
            listSingle: id => {
                return `jobs/${id}?join=${joins}`
            },
            mutation: `jobs?join=${joins}`,
            requestRespond: id => {
                return `jobs/${id}/technician-requests/respond?join=${joins}`;
            },
            updateFittings: id => {
                return `jobs/${id}/fittings?join=${joins}`;
            },
            sendCommonTechnicianMessage: id => {
                return `jobs/${id}/technician-message?join=${joins}`;
            },
            close: (id, status) => {
                return `jobs/${id}/close/${status}`;
            },
            checkQrCode: `jobs/qrcode_check`
        }
    }
}